export const DISCOVERY_SOURCES = [
  { key: "facebook", label: "Facebook", mark: "f" },
  { key: "instagram", label: "Instagram", mark: "◎" },
  { key: "tiktok", label: "TikTok", mark: "♪" },
  { key: "youtube", label: "YouTube", mark: "▶" },
  { key: "linkedin", label: "LinkedIn", mark: "in" },
  { key: "x", label: "X", mark: "X" },
  { key: "google_search", label: "Google Search", mark: "G" },
  { key: "other_search", label: "Other search", mark: "⌕" },
  { key: "friend_colleague", label: "Friend or colleague", mark: "◉" },
  { key: "online_ad", label: "Online ad", mark: "✦" },
  { key: "blog_article", label: "Blog or article", mark: "▤" },
  { key: "another_website", label: "Another website", mark: "↗" },
  { key: "event", label: "Event", mark: "▦" },
  { key: "other", label: "Other", mark: "…" },
] as const;

export type DiscoverySource = typeof DISCOVERY_SOURCES[number]["key"];
export const DISCOVERY_SKIPPED = "prefer_not_to_say" as const;
